import { useEffect, useState } from 'react';
import { Profile } from './Profile';
import { useTranslation } from 'react-i18next';

export type CDKContactProfile = {
  firstName: string;
  lastName: string;
  title: string;
  phoneNo: string;
  email: string;
};

export const MeetMyTeamList = ({data,isAdmin,isMyCdkTeamAccess}:any) =>{
    const [profiles, setProfiles] = useState<CDKContactProfile[]>([]);
    const [noDataFound,setNoDataFound] = useState<boolean>();
    const { t } = useTranslation();

    useEffect(()=>{
      if (data === null || (data && data.length === 0)){
        setNoDataFound(true);
      }
      if (data){
        setProfiles(data);
      }
    },[data]);

    return (
      <div role="list" style={{marginTop:'20px'}}>
       {noDataFound && <div>{t('meetmycdkteam.contactNotFound')}</div>}
       {profiles?.map((profile:any,index:any) =>(
          <Profile profile={profile} key={index} isAdmin={isAdmin} isMyCdkTeamAccess={isMyCdkTeamAccess}></Profile>
        ))}
      </div>
    )
  }